import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children, changeLanguage, activeLanguage }) => (
	<div className="page-wrapper">
		<div className="preloader" />

		<Header
			changeLanguage={changeLanguage}
			activeLanguage={activeLanguage}
		/>
		{children}
		<Footer />

		<div className="scroll-to-top scroll-to-target" data-target="html">
			<span className="fa fa-arrow-up" />
		</div>
	</div>
);

export default Layout;



// WEBPACK FOOTER //
// ./src/components/layout/Layout.js